<template>
  <el-dialog
    class="add-ca-service-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="区块链ID" prop="chainId">
        <el-select v-model="editForm.chainId" placeholder="请选择" class="select-full">
          <el-option
            v-for="item in options"
            :key="item.ChainId"
            :label="item.ChainId"
            :value="item.ChainId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateTask',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    return {
      title: '变更区块链',
      dialogVisible: false,
      disabled: false,
      editForm: {
        chainId: ''
      },
      editRules: {
        chainId: [{ required: true, message: '请选择区块链ID', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 80
      },
      options: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleCancel() {
      this.editForm = {
        chainId: ''
      }
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
      this.getList()
    },
    getList() {
      this.$apis.privacy.getChainList().then(res => {
        if (res.data) {
          this.options = res.data.items ? res.data.items : []
          let chainId = sessionStorage.getItem('cbaas_privacy_chain_id')
          let firstChainId = res.data.items ? res.data.items[0]['ChainId'] : ''
          // 如果没有存过，存第一个Chainid
          if (!chainId) {
            this.$store.commit('updateComputingChainId', firstChainId)
            sessionStorage.setItem('cbaas_privacy_chain_id', firstChainId)
            this.getClientInfo(firstChainId)
          } else {
            let index = this.options.findIndex(ele => ele.ChainId == chainId)
            // 否则判断存储的Chainid当前列表是否存在，如果存在，直接存储vuex
            if (index > -1) {
              // 选择框回显
              this.editForm.chainId = this.options[index]['ChainId']
              this.$store.commit('updateComputingChainId', chainId)
              this.getClientInfo(chainId)
            } else {
              // 如果不存在了，重新给第一个chainid
              this.$store.commit('updateComputingChainId', firstChainId)
              sessionStorage.setItem('cbaas_privacy_chain_id', firstChainId)
              this.getClientInfo(firstChainId)
            }
          }
          this.$emit('updateChainName')
        }
      })
    },
    getClientInfo(chainId) {
      this.$apis.privacy.getChainClientInfo({ chainId }).then(res => {
        sessionStorage.setItem('cbaas_privacy_chain_client', JSON.stringify(res.data))
      })
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$store.commit('updateComputingChainId', this.editForm.chainId)
          sessionStorage.setItem('cbaas_privacy_chain_id', this.editForm.chainId)
          this.getClientInfo(this.editForm.chainId)
          this.handleCancel()
          this.$emit('updateChainName')
        } else {
          this.$message.warning('请填写内容')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-ca-service-dialog.common-dialog {
  /deep/ .el-dialog {
    width: 400px;
  }
  .select-full {
    width: 100%;
  }
}
</style>
